/**
 * Created by jonas on 2021-02-02.
 */

import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {IBlitzKriegGameData, IBlitzKriegInitData} from "./data/IBlitzKriegData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {BlitzKriegParsedInitData} from "./data/BlitzKriegParsedInitData";
import {BlitzKriegParsedGameData} from "./data/BlitzKriegParsedGameData";
import {BlitzKriegDataParser} from "./data/BlitzKriegDataParser";
import {DDay} from "../DDay";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DDayGameConfig} from "../DDayGameConfig";

export class BlitzKriegModel extends GameModel<IBlitzKriegInitData, IBlitzKriegGameData> {

    public parsedInitData: BlitzKriegParsedInitData;
    public parsedGameData: BlitzKriegParsedGameData;
    public reels: string[][];
    public isRestore: boolean = false;
    public isRestoreFeatureBet: boolean;
    public buyFeatureName: string;
    public nextPlayerInteraction: any;

    private _parser: BlitzKriegDataParser;

    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);
        api.events.once("featureBet", (data: boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data: string) => {
            this.buyFeatureName = data;
        });
        DDay.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < DDay.model.initData.featureBuyTimesBetValue.length; index++) {
                if (DDay.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });

        DDay.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < DDay.model.initData.featureBuyTimesBetValue.length; index++) {
                if (DDay.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
        this._parser = new BlitzKriegDataParser();
    }

    protected onInit(data: IBlitzKriegInitData): void {
        this.parsedInitData = new BlitzKriegParsedInitData(data, this._parser);
        this.reels = this.changeInitReelsData(this.parsedInitData.reels);
        this.isRestore = data.isRestoreState;
        this.nextPlayerInteraction = data.nextPlayerInteraction;
        super.onInit(data);
    }

    protected onGame(data: IBlitzKriegGameData): void {
        this.parsedGameData = new BlitzKriegParsedGameData(data, this._parser);
        this.reels = this.parsedGameData.reels;
        this.isRestore = false;
        super.onGame(data);
    }

    protected changeInitReelsData(reels: string[][]): string[][] {
        reels.forEach((reelData: string[]) => {
            reelData.unshift("L1");
            reelData.push("L1");
        });
        return reels;
    }
}
